module.exports = __webpack_public_path__ + "fonts/Merriweather-400-latin-ext15.00e97a0.woff2";